"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.aiStatisticsActionListApi = aiStatisticsActionListApi;
exports.aiStatisticsConversationListApi = aiStatisticsConversationListApi;
exports.aiStatisticsConversationMessagesApi = aiStatisticsConversationMessagesApi;
exports.aiStatisticsOverviewApi = aiStatisticsOverviewApi;
exports.aiStatisticsUserDetailApi = aiStatisticsUserDetailApi;
exports.aiStatisticsUserListApi = aiStatisticsUserListApi;
exports.aiStatisticsUserRankingApi = aiStatisticsUserRankingApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// AI 统计总览：token 消耗、AI 创建活动/集市/报名数、按天趋势
function aiStatisticsOverviewApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/ai_statistics/overview',
    method: 'get',
    params: params
  });
}

// 用户 token 消耗排名
function aiStatisticsUserRankingApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/ai_statistics/user/ranking',
    method: 'get',
    params: params
  });
}

// 用户维度统计分页列表
function aiStatisticsUserListApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/ai_statistics/user/list',
    method: 'get',
    params: params
  });
}

// 指定用户统计详情
function aiStatisticsUserDetailApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/ai_statistics/user/detail',
    method: 'get',
    params: params
  });
}

// 用户 AI 会话列表（聊天记录）
function aiStatisticsConversationListApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/ai_statistics/conversation/list',
    method: 'get',
    params: params
  });
}

// 会话聊天消息
function aiStatisticsConversationMessagesApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/ai_statistics/conversation/messages',
    method: 'get',
    params: params
  });
}

// AI 动作明细（创建活动/创建集市/活动报名）
function aiStatisticsActionListApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/ai_statistics/action/list',
    method: 'get',
    params: params
  });
}